import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import SideBarViewStyles from "../../Styles/ChannelViewer/SideBarView.module.css";
import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";
import SideBar from "./SideBar";
import UserSideBar from "./UserSideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import Image from "../../Common/Image.component/Image";

const SideBarViews = () => {
  const [{ loadedMember, resizeFlag, showTimesIcon }, dispatch] =
    useContext(ContextForClient);
  const [sidaBarsComponents, setsidaBarsComponents] = useState([]);
  const [size, setSize] = useState(0);
  const { Sidebarcontainer, hideSideBars, profile } = SideBarViewStyles;
  const loggerNames = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    const fetchChannel = async () => {
      const storage = "channels",
        url = "allchannel";

      await fetchRequest({
        url,
        storage,
        dispatch,
      });
    };
    fetchChannel();

    const switchSideBars = () => {
      switch (loadedMember) {
        case true:
          setsidaBarsComponents(<UserSideBar />);
          break;

        case false:
          setsidaBarsComponents(<SideBar />);
          break;

        default:
          setsidaBarsComponents(<SideBar />);
          break;
      }
    };

    switchSideBars();

    const handleResizeScreen = () => {
      if (size <= 700) {
        dispatch({ type: "RESIZE_SCREEN", payload: false });
      } else {
        dispatch({ type: "RESIZE_SCREEN", payload: true });
      }
    };
    handleResizeScreen();
    return () => {
      fetchChannel();
      switchSideBars();
      handleResizeScreen();
    };
  }, [dispatch, loadedMember, size]);

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize(window.innerWidth);
    };
    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const userAbbrev =
    loggerNames && loggerNames.names.split(" ").length > 1
      ? `${loggerNames.names.split(" ")[0][0].toUpperCase()}${loggerNames.names
          .split(" ")[1][0]
          .toUpperCase()}`
      : loggerNames.names.split(" ")[0][0].toUpperCase();

  return (
    <div className={Sidebarcontainer}>
      {sidaBarsComponents}
      {resizeFlag && showTimesIcon && (
        <span className={hideSideBars}>
          {
            <FontAwesomeIcon
              icon={faTimesCircle}
              color="#fff"
              size="2x"
              onClick={() =>
                `${dispatch({ type: "RESIZE_SCREEN", payload: false })}, 
                ${dispatch({ type: "SHOW_TIMES_ICON", payload: false })}
                `
              }
              cursor="pointer"
            />
          }
        </span>
      )}
      {resizeFlag && (
        <div
          className={`container-fluid d-flex align-items-center justify-content-around ${profile}`}
        >
          <div>
            {loggerNames && loggerNames.profileImage ? (
              <Image src={loggerNames.profileImage} alt="User Image" />
            ) : (
              <div className="card p-2" style={{ backgroundColor: "#aaa" }}>
                <span>{userAbbrev}</span>
              </div>
            )}
          </div>
          <div className="text-capitalize" style={{ color: "#aaa" }}>
            {loggerNames.names}
          </div>
          <span>
            <FontAwesomeIcon icon={faAngleDown} color="#aaa" />
          </span>
        </div>
      )}
    </div>
  );
};

export default SideBarViews;
